/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import Calendar from './calendar/ca_ES';
import DatePicker from './date-picker/ca_ES';
import Pagination from './pagination/ca_ES';
import TimePicker from './time-picker/ca_ES';

export default {
  locale: 'ca',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtrar Menu',
    filterConfirm: 'OK',
    filterReset: 'Restablir',
    selectAll: 'Seleccionar tot',
    selectInvert: 'Invertir selecciÃ³'
  },
  Modal: {
    okText: 'Acceptar',
    cancelText: 'CancelÂ·lar',
    justOkText: 'Acceptar'
  },
  Popconfirm: {
    okText: 'Acceptar',
    cancelText: 'CancelÂ·lar'
  },
  Transfer: {
    searchPlaceholder: 'Cercar aquÃ­',
    itemUnit: 'element',
    itemsUnit: 'elements'
  },
  Upload: {
    uploading: 'Pujant...',
    removeFile: 'Eliminar fitxer',
    uploadError: 'Error al pujar el fitxer',
    previewFile: 'Vista prÃ¨via'
  },
  Empty: {
    description: 'No hi ha dades'
  }
};
